import React from 'react';
import {
  Alert,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Switch,
  Typography
} from '@mui/material';

const SiteProductLocationsModal = ({
  open,
  onClose,
  product,
  locations,
  locationStates,
  loading,
  savingLocationId,
  onToggle,
  canManageSites = false
}) => {
  const hasLocations = Array.isArray(locations) && locations.length > 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Disponibilidad por sucursal
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {product?.name || 'Producto'}
        </Typography>

        {product?.enabled === false && (
          <Alert severity="info" sx={{ mb: 2 }}>
            Este producto está desactivado globalmente en la web. Aunque habilites sucursales aquí, no se mostrará hasta volver a activarlo globalmente.
          </Alert>
        )}

        {!hasLocations && (
          <Alert severity="warning">
            No hay sucursales configuradas como disponibles en la web.
          </Alert>
        )}

        {hasLocations && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {locations.map((location) => {
              const checked = locationStates[location.id] !== false;
              const disabled = loading || savingLocationId === location.id || !canManageSites;

              return (
                <Box
                  key={location.id}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 2,
                    px: 2,
                    py: 1.25
                  }}
                >
                  <Box>
                    <Typography variant="body1">{location.name}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      ID {location.id}
                    </Typography>
                  </Box>
                  <Switch
                    checked={checked}
                    disabled={disabled}
                    onChange={(event) => onToggle(location.id, event.target.checked)}
                  />
                </Box>
              );
            })}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SiteProductLocationsModal;
